(() => {
  const script = document.querySelector('script[data-crux-cart-campaign-sync]');
  if (!script) return;

  const version = script.dataset.cruxCampaignVersion || '';
  const nextBoundary = Date.parse(script.dataset.cruxCampaignNextBoundary || '');
  const root = window.Shopify?.routes?.root || '/';
  const attributeKey = 'crux_campaign_version__';
  const attemptKey = 'crux-cart-campaign-sync:' + version;

  const request = (path, options = {}) => fetch(root + path, {
    credentials: 'same-origin',
    cache: 'no-store',
    ...options,
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
  });

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'USD',
      }).format(Number(cents || 0) / 100);
    } catch {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function appendPrice(container, original, discounted, currency, lineStyle) {
    if (!(container instanceof HTMLElement)) return;
    const hasDiscount = Number(original) > Number(discounted);
    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = lineStyle ? 'flex-end' : 'center';
    wrapper.style.justifyContent = lineStyle ? 'center' : 'flex-start';
    wrapper.style.gap = '6px';
    wrapper.style.marginTop = lineStyle ? '0' : '4px';
    if (lineStyle) wrapper.style.flexDirection = 'column';

    if (hasDiscount) {
      const originalPrice = document.createElement('s');
      originalPrice.textContent = money(original, currency);
      originalPrice.style.opacity = '0.6';
      originalPrice.style.fontSize = '0.85rem';
      wrapper.append(originalPrice);

      const priceRow = document.createElement('div');
      priceRow.style.display = 'flex';
      priceRow.style.alignItems = 'center';
      priceRow.style.gap = '8px';
      if (lineStyle && Number(original) > 0) {
        const badge = document.createElement('span');
        badge.textContent = Math.round((Number(original) - Number(discounted)) * 100 / Number(original)) + '% OFF';
        badge.style.cssText = 'background:#e53935;color:#fff;font-size:.7rem;font-weight:bold;padding:3px 6px;border-radius:4px;letter-spacing:.5px;line-height:1';
        priceRow.append(badge);
      }
      const finalPrice = document.createElement('span');
      finalPrice.textContent = money(discounted, currency);
      finalPrice.style.color = '#e53935';
      finalPrice.style.fontWeight = '700';
      if (lineStyle) finalPrice.style.fontSize = '1.15rem';
      priceRow.append(finalPrice);
      wrapper.append(priceRow);
    } else {
      const regularPrice = document.createElement('span');
      regularPrice.textContent = money(discounted, currency);
      wrapper.append(regularPrice);
    }
    container.replaceChildren(wrapper);
  }

  function renderCartPrices(cart) {
    if (!cart?.items?.length) return;
    const byKey = new Map(cart.items.map((item) => [item.key, item]));
    document.querySelectorAll('.cart-items__table-row[data-key]').forEach((row) => {
      const item = byKey.get(row.dataset.key);
      if (!item) return;
      appendPrice(
        row.querySelector('[data-crux-cart-unit-price]'),
        item.original_price,
        item.discounted_price ?? item.final_price,
        cart.currency,
        false
      );
      appendPrice(
        row.querySelector('[data-crux-cart-line-price-content]'),
        item.original_line_price,
        item.line_price ?? item.final_line_price,
        cart.currency,
        true
      );
    });
  }

  async function revalidate() {
    if (!version || sessionStorage.getItem(attemptKey) === 'running') return;
    const cartResponse = await request('cart.js');
    if (!cartResponse.ok) throw new Error('Unable to read cart');
    const cart = await cartResponse.json();
    renderCartPrices(cart);
    if (!cart.item_count || cart.attributes?.[attributeKey] === version) return;

    sessionStorage.setItem(attemptKey, 'running');
    const updateResponse = await request('cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ attributes: { [attributeKey]: version } }),
    });
    if (!updateResponse.ok) throw new Error('Unable to revalidate cart');
    const updated = await updateResponse.json();
    if (updated.attributes?.[attributeKey] !== version) throw new Error('Cart campaign version was not saved');

    renderCartPrices(updated);

    sessionStorage.setItem(attemptKey, 'complete');
    window.location.reload();
  }

  function run() {
    revalidate().catch((error) => {
      sessionStorage.removeItem(attemptKey);
      console.warn('[CRUX] Cart campaign revalidation deferred:', error.message);
    });
  }

  function scheduleBoundary() {
    if (!Number.isFinite(nextBoundary) || nextBoundary <= Date.now()) return;
    const remaining = nextBoundary - Date.now() + 1500;
    const delay = Math.min(remaining, 2147483647);
    window.setTimeout(() => {
      if (remaining > 2147483647) scheduleBoundary();
      else run();
    }, delay);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  const refreshDisplayedPrices = () => window.setTimeout(() => {
    request('cart.js').then((response) => response.json()).then(renderCartPrices).catch(() => {});
  }, 150);
  document.addEventListener('cart:update', refreshDisplayedPrices);
  document.addEventListener('discount:update', refreshDisplayedPrices);
  scheduleBoundary();
})();